import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VersionLinkComponent } from 'src/components/version-link/version-link.component';

@NgModule({
  declarations: [VersionLinkComponent],
  imports: [
    CommonModule
  ],
  exports: [VersionLinkComponent],
})
export class SharedModule { }
